import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';

const buildStyle = (
  { backgroundColor, borderColor, depth },
  { readingDirection }
) => {
  const boxShadow = depth.boxShadow.hard;
  return {
    mainContainer: {
      base: {
        overflow: 'hidden',
        display: 'none',
        height: 0,
        opacity: 0
      },
      iePositioning: {
        position: 'relative'
      },
      animatedTransition: {
        transition: 'opacity 400ms 0ms'
      }
    },
    contentContainer: {
      base: {
        boxSizing: 'border-box',
        margin: 0,
        padding: 16
      },
      noPadding: {
        padding: 0
      },
      animatedTransition: {
        '*': {
          opacity: 0
        }
      }
    },
    openContainer: {
      mainContainer: {
        base: {
          display: 'block',
          height: '100%',
          opacity: 1
        },
        animatedTransition: {
          transition: 'opacity 600ms 0ms'
        }
      },
      contentContainer: {
        animatedTransition: {
          '*': {
            opacity: 1
          }
        }
      }
    },
    popoverContainer: {
      base: {
        border: `1px solid ${borderColor.base}`,
        backgroundColor: backgroundColor.base,
        boxShadow: `${boxShadow.xOffset} ${boxShadow.yOffset}
          ${boxShadow.blurRadius} ${boxShadow.spreadRadius} ${boxShadow.color}`,
        zIndex: depth.zIndex[100],
        overflowY: 'auto'
      }
    },
    readingDirection
  };
};

const useStyle = (isRtl, isOpen, nonAnimated, zIndex, hasPadding) => {
  const {
    mainContainer,
    contentContainer,
    openContainer,
    popoverContainer,
    readingDirection
  } = useBuildStyleWithTheme(buildStyle, { isRtl });

  return {
    mainContainer: {
      ...mainContainer.base,
      ...(!isOpen && mainContainer.iePositioning),
      ...(isOpen && openContainer.mainContainer.base),
      ...(isOpen && openContainer.mainContainer.animatedTransition),
      ...(!nonAnimated && mainContainer.animatedTransition)
    },
    contentContainer: {
      ...contentContainer.base,
      ...(!nonAnimated &&
        (isOpen
          ? openContainer.contentContainer.animatedTransition
          : contentContainer.animatedTransition)),
      ...(!hasPadding && contentContainer.noPadding)
    },
    popoverContainer: {
      ...popoverContainer.base,
      ...(zIndex && { zIndex }),
      ...readingDirection
    }
  };
};

export default useStyle;
